import React from "react";
import { Link } from "react-router-dom";
import { Car, Users, ArrowRight, Sparkles } from "lucide-react";

export default function RegisterChoice() {
  return (
    <div className="mx-auto max-w-4xl px-4 py-14 sm:px-6 sm:py-20 lg:px-10" data-testid="register-choice-page">
      <div className="inline-flex items-center gap-2 rounded-full bg-primary/10 px-3 py-1.5 text-[10px] uppercase tracking-widest text-primary sm:text-xs">
        <Sparkles className="h-3.5 w-3.5" />
        <span>Inscription Price Covoiturage</span>
      </div>
      <h1 className="mt-3 font-[Outfit] text-3xl font-semibold tracking-tight sm:text-4xl">
        Vous êtes ?
      </h1>
      <p className="mt-3 max-w-xl text-sm leading-relaxed text-muted-foreground">
        Choisissez votre profil — on s&apos;occupe du reste, promis&nbsp;!
      </p>

      <div className="mt-10 grid gap-5 md:grid-cols-2">
        <ChoiceCard
          to="/register/client"
          icon={<Users className="h-7 w-7" />}
          title="Covoiturage"
          desc="Vous cherchez à réserver une place pour un trajet partagé, ponctuel ou régulier."
          highlights={["Adresse de départ auto via GPS", "Paiement carte ou cash", "Suivi en direct du chauffeur"]}
          testId="choice-client"
          accent="primary"
        />
        <ChoiceCard
          to="/register/driver"
          icon={<Car className="h-7 w-7" />}
          title="Chauffeur"
          desc="Vous conduisez et proposez vos trajets pour rentabiliser vos déplacements."
          highlights={["Courses à proximité", "Historique & revenus", "Notifications instantanées"]}
          testId="choice-driver"
          accent="accent"
        />
      </div>
    </div>
  );
}

function ChoiceCard({ to, icon, title, desc, highlights, testId, accent = "primary" }) {
  const tone = accent === "accent"
    ? "bg-accent/15 text-accent-foreground ring-accent/40"
    : "bg-primary/10 text-primary ring-primary/40";
  return (
    <Link
      to={to}
      data-testid={testId}
      className="group relative block rounded-3xl border-2 border-border/60 bg-card p-6 shadow-sm transition-all hover:-translate-y-1 hover:border-primary/40 hover:shadow-xl cartoon-shadow"
    >
      <div className="flex items-start justify-between gap-3">
        <div className={`grid h-14 w-14 place-items-center rounded-2xl ring-2 ${tone} animate-wobble-tiny`}>{icon}</div>
        <ArrowRight className="h-5 w-5 text-muted-foreground transition-transform group-hover:translate-x-1 group-hover:text-primary" />
      </div>
      <h2 className="mt-4 font-[Outfit] text-2xl font-semibold tracking-tight">{title}</h2>
      <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{desc}</p>
      <ul className="mt-4 space-y-1.5 text-xs text-foreground/80">
        {highlights.map((h) => (
          <li key={h} className="flex items-start gap-1.5">
            <span className="mt-1.5 h-1.5 w-1.5 flex-none rounded-full bg-primary" /> {h}
          </li>
        ))}
      </ul>
    </Link>
  );
}
